import { render, staticRenderFns } from "./payDataSource.vue?vue&type=template&id=19a8d8ae&scoped=true&"
import script from "./payDataSource.vue?vue&type=script&lang=js&"
export * from "./payDataSource.vue?vue&type=script&lang=js&"
import style0 from "./payDataSource.vue?vue&type=style&index=0&id=19a8d8ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a8d8ae",
  null
  
)

export default component.exports